import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ClockIcon } from "assets/icons";
import Board from "components/Common/Board/Board";
import dayjs from "dayjs";
import React from "react";
import styled, { css } from "styled-components";

interface CalendarTimerProps {
  date?: Date;
  onChangeTime: (date: Date) => void;
}

const CalendarTimer = ({ date, onChangeTime }: CalendarTimerProps) => {
  const timeArray = Array.from({ length: 24 }, (_, i) => i);
  const minuteArray = Array.from({ length: 60 }, (_, i) => i);

  const [isOpen, setIsOpen] = React.useState(false);

  const handleTimeChange = (hour: number, minute: number) => {
    // dayjs를 사용하여 새로운 날짜 객체 생성
    const newDate = dayjs(date).hour(hour).minute(minute).toDate(); // dayjs 객체를 JavaScript Date 객체로 변환
    onChangeTime(newDate);
  };

  return (
    <CalendarTimerLayout>
      <p>Time</p>

      <DropdownMenu.Root open={isOpen} modal>
        <DropdownMenu.Trigger asChild onClick={() => setIsOpen(true)}>
          <button>
            {dayjs(date).format("HH:mm")}
            <ClockIcon />
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content
          onInteractOutside={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen(false);
          }}
        >
          <CalendarTimerDropdownLayout isShadow>
            <div>
              {timeArray.map((time) => (
                <CalendarTimerDropdownButton
                  isSelected={dayjs(date).hour() === time}
                  key={time}
                  onClick={() => handleTimeChange(time, dayjs(date).minute())}
                >
                  {time.toString().padStart(2, "0")}
                </CalendarTimerDropdownButton>
              ))}
            </div>
            <div>
              {minuteArray.map((minute) => (
                <CalendarTimerDropdownButton
                  isSelected={dayjs(date).minute() === minute}
                  key={minute}
                  onClick={() => handleTimeChange(dayjs(date).hour(), minute)}
                >
                  {minute.toString().padStart(2, "0")}
                </CalendarTimerDropdownButton>
              ))}
            </div>
          </CalendarTimerDropdownLayout>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </CalendarTimerLayout>
  );
};

export default CalendarTimer;

const CalendarTimerLayout = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.typography.body3.regular};

  > p {
    color: ${({ theme }) => theme.color.text.secondary};
  }

  > button {
    display: flex;
    align-items: center;
    gap: 2rem;
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.color.grey[700]};
    padding: 1.1rem 1.4rem;
  }
`;

const CalendarTimerDropdownLayout = styled(Board)`
  padding: 1.2rem;
  border-radius: 1.6rem;

  display: flex;
  gap: 0.4rem;

  > div {
    flex: 1;
    white-space: nowrap;
    max-height: 27rem;
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

const CalendarTimerDropdownButton = styled(DropdownMenu.Item)<{
  isSelected: boolean;
}>`
  ${({ isSelected, theme }) => css`
    background-color: ${isSelected
      ? theme.color.background.dark
      : "transparent"};
    color: ${isSelected
      ? theme.color.text.highEmphasis
      : theme.color.text.default};
  `};
  padding: 0.8rem 1.4rem;
  cursor: pointer;
  min-width: 5rem;
`;
